module.exports = __webpack_public_path__ + "static/media/ig21.173c0998.jpg";